import {Injectable} from '@angular/core';
import {BehaviorSubject, catchError, defer, MonoTypeOperatorFunction, Observable, of, tap} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ScreenSpinnerService {
  get loading$(): Observable<boolean> {
    return this._loading$.asObservable()
  }

  protected readonly _loading$ = new BehaviorSubject(false)

  constructor() {
  }

  setLoading(value: boolean): void {
    this._loading$.next(value);
  }

  loading(): void {
    this.setLoading(true);
  }

  stopLoading(): void {
    this.setLoading(false);
  }

  withSpinner = <T>(): MonoTypeOperatorFunction<T> => (source$: Observable<T>) => defer(() => {
    this.loading();

    return source$.pipe(
      tap(() => this.stopLoading()),
      catchError(e => {
        this.stopLoading()

        return of(e)
      })
    );
  });
}
